import { useEffect, useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetAllcompanyQuery } from "../../../../store/api/itemtaxapi"
import Table from './Table';
const Tab1 = ({ handleChange, pageState, setPageState , selectedTaxAccounts}) => {
  const [companys, setCompanys] = useState([])
  const { data: companydata, isLoading, isError } = useGetAllcompanyQuery()
  const gstOptions = [{ "name": "Taxable" }, { "name": "Nil-Rated" }, { "name": "Exmpted" }, { "name": "Non-GST" }]

  useEffect(() => {
    if (companydata) {
      setCompanys(companydata.data)
    }
  }, [companydata])

  return (
     <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>

        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

              <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                    <Input
                    name='title'
                    label="Title"
                    value={pageState.title}
                    onChange={(e) => handleChange('title', e.target.value)}
                    style={{ height: "30px" }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                   <SelectSearch
                                      list={gstOptions}
                                      label="GST Treatment"
                                      value={pageState.gst_treatment}
                                      onChange={(val) => handleChange('gst_treatment', val)}
                                      getOptionLabel={(item) => item.name}
                                      getOptionValue={(item) => item.name}
                                      placeholder="GST Treatment"
                                    />
                  

                </div>
                {pageState.gst_treatment == 'Taxable' && (
                
                <div style={{ flex: 1 }}>
                   
                     <Input
                name="gst_rate"
                type='number'
                value={pageState.gst_rate}
                label="GST Rate"
                 onChange={(e) => handleChange('gst_rate', e.target.value)}
                style={{ height: "30px" }}
              />
                </div>
                 )}
                <div style={{ flex: 1 }}>
                   <SelectSearch
                                      list={companys}
                                      label="Company"
                                      value={pageState.company}
                                      onChange={(val) => handleChange('company', val)}
                                      getOptionLabel={(item) => item.name}
                                      getOptionValue={(item) => item.name}
                                      placeholder="Company"
                                    />
                  
                </div> 
               
              </div>







            </div>
          </div>

        </div>

       
    <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >

            <div className="col-md-12">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
 <div style={{ display: 'flex', gap: '15px'}}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Rates</p>
                </div>
              </div>
<Table
  compname={pageState.company}
  selectedTaxAccounts={{
    value: pageState.selectedTaxAccounts,
    setValue: (v) => setPageState({ ...pageState, selectedTaxAccounts: v }),
  }}
/>





              </div>
            </div>

          </div>


       
        
      </div>
    </div>
  )
}

export default Tab1